export default __webpack_public_path__ + "static/media/linkedin.08c23c22.svg";